// AWS Cognito Configuration
const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID || "";
const USER_POOL_CLIENT_ID = process.env.REACT_APP_USER_POOL_CLIENT_ID || "";

// DynamoDB Table
const QUESTION_ANSWERS_TABLE_NAME = process.env.REACT_APP_DYNAMODB_TABLE_NAME || "";

const APP_NAME = "SHIPA Analytics Assistant";
const APP_SUBJECT = "SHIPA Freight Forwarding Operations";
const WELCOME_MESSAGE = "I'm your SHIPA Freight Forwarding Analytics Assistant, providing logistics insights and operational analysis.";

const AGENT_ENDPOINT_URL = process.env.REACT_APP_AGENT_ENDPOINT_URL || "";
const MAX_LENGTH_INPUT_SEARCH = 140;
const MODEL_ID_FOR_CHART = "us.anthropic.claude-3-7-sonnet-20250219-v1:0"; // Claude 3.7 Sonnet

// Simplified CHART_PROMPT
const CHART_PROMPT = 
  "Create detailed ApexCharts.js configurations.\n\n" +
  "<information>\n" +
  "  <summary><<answer>></summary>\n" +
  "  <data_sources><<data_sources>></data_sources>\n" +
  "</information>\n\n" +
  "Output format:\n" +
  "<has_chart>1</has_chart>\n" +
  "<chart_type>[bar/line/pie]</chart_type>\n" +
  "<chart_configuration>[JSON]</chart_configuration>\n" +
  "<caption>[Analysis in 20-40 words]</caption>";

export {
  CHART_PROMPT,
  QUESTION_ANSWERS_TABLE_NAME,
  APP_NAME,
  APP_SUBJECT,
  WELCOME_MESSAGE,
  AGENT_ENDPOINT_URL,
  MODEL_ID_FOR_CHART,
  MAX_LENGTH_INPUT_SEARCH,
  USER_POOL_ID,
  USER_POOL_CLIENT_ID,
};
